<div id="myInfoMainContainer" class="main-container" data-cy="patient-portal-my-info-main-container">

  @if (isLoading) {
    <div class="spinner-container" data-cy="patient-portal-my-info-spinner-container">
      <mat-spinner data-cy="patient-portal-my-info-spinner"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="main-content-container" data-cy="patient-portal-my-info-main-content-container">
      <!--moveSelectedTab-->
      <mat-tab-group [selectedIndex]="selectedTab" animationDuration="0ms" (selectedTabChange)="handleTabChange($event)" data-cy="patient-portal-my-info-tab-group">
        <mat-tab data-cy="patient-portal-my-info-back-tab">
          <ng-template mat-tab-label>
            <span data-cy="patient-portal-my-info-back-tab"><< Back</span>
          </ng-template>
        </mat-tab>
        <mat-tab style="padding: 15px !important;" data-cy="patient-portal-my-info-personal-information-tab">
          <ng-template mat-tab-label>
            <span data-cy="patient-portal-my-info-personal-information-tab">Personal Information</span>
          </ng-template>
          <div class="information-container personal-information-form-container" data-cy="patient-portal-my-info-personal-information-container">
            <div class="information-container mat-elevation-z2" data-cy="patient-portal-my-info-personal-information-form-container">
              <div style="display: flex;flex-flow: row;" class="personal-information-name" data-cy="patient-portal-my-info-name-row">
                <mat-form-field class="input-field input-field-small" data-cy="patient-portal-my-info-title-form-field">
                  <mat-label data-cy="patient-portal-my-info-title-label">Title</mat-label>
                  <mat-select [(ngModel)]="PatientContact.enumSalutationID" data-cy="patient-portal-my-info-title-select">
                    @for (option of enumSalutations; track option) {
                      <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-my-info-title-option">
                        {{option.ItemDisplayValue}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field  [ngClass]="(isTabletPortrait || isTabletLandscape) ? 'input-field input-field-medium' :  'input-field input-field-full'" data-cy="patient-portal-my-info-first-name-form-field">
                  <mat-label data-cy="patient-portal-my-info-first-name-label">First Name</mat-label>
                  <input matInput [(ngModel)]="PatientContact.FirstName" required data-cy="patient-portal-my-info-first-name-input" maxlength="50">
                </mat-form-field>
                <mat-form-field  [ngClass]="(isTabletPortrait || isTabletLandscape) ? 'input-field input-field-medium' :  'input-field input-field-full'" data-cy="patient-portal-my-info-last-name-form-field">
                  <mat-label data-cy="patient-portal-my-info-last-name-label">Last Name</mat-label>
                  <input matInput [(ngModel)]="PatientContact.LastName" required data-cy="patient-portal-my-info-last-name-input" maxlength="50">
                </mat-form-field>
                <mat-form-field class="input-field input-field-small" data-cy="patient-portal-my-info-suffix-form-field">
                  <mat-label data-cy="patient-portal-my-info-suffix-label">Suffix</mat-label>
                  <mat-select [(ngModel)]="PatientContact.enumNameSuffixID" data-cy="patient-portal-my-info-suffix-select">
                    @for (option of enumSuffixes; track option) {
                      <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-my-info-suffix-option">
                        {{option.ItemDisplayValue}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="display: flex;flex-flow: row;" class="personal-information-dob-gender-ssn" data-cy="patient-portal-my-info-dob-gender-ssn-row">
                <mat-form-field class="input-field-medium" data-cy="patient-portal-my-info-dob-form-field">
                  <mat-label data-cy="patient-portal-my-info-dob-label">Date of Birth</mat-label>
                  <input matInput [matDatepicker]="picker" [(ngModel)]="PatientContact.BirthDate" required data-cy="patient-portal-my-info-dob-input">
                  <mat-datepicker-toggle matSuffix [for]="picker" data-cy="patient-portal-my-info-dob-datepicker-toggle"></mat-datepicker-toggle>
                  <mat-datepicker #picker data-cy="patient-portal-my-info-dob-datepicker"></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-my-info-gender-form-field">
                  <mat-label data-cy="patient-portal-my-info-gender-label">Gender</mat-label>
                  <mat-select [(ngModel)]="PatientContact.enumGenderID" data-cy="patient-portal-my-info-gender-select">
                    @for (option of enumGenders; track option) {
                      <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-my-info-gender-option">
                        {{option.ItemDisplayValue}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field  [ngClass]="(isTabletPortrait || isTabletLandscape) ? 'input-field input-field-medium' :  'input-field input-field-full'" data-cy="patient-portal-my-info-ssn-form-field">
                  @if (isTabletPortrait) {
                    <mat-label data-cy="patient-portal-my-info-ssn-label-tablet">SSN</mat-label>
                  }
                  @if (!isTabletPortrait) {
                    <mat-label data-cy="patient-portal-my-info-ssn-label-desktop">Social Security Number</mat-label>
                  }
                  <input matInput [(ngModel)]="PatientContact.GovermentIdentificationNo2" data-cy="patient-portal-my-info-ssn-input">
                </mat-form-field>
              </div>
              <div class="input-section-header" data-cy="patient-portal-my-info-address-header">
                Address
              </div>
              <mat-form-field class="input-field input-field-full" data-cy="patient-portal-my-info-address-line-1-form-field">
                <mat-label data-cy="patient-portal-my-info-address-line-1-label">Address Line 1</mat-label>
                <input matInput [(ngModel)]="PatientAddress.Address1" required data-cy="patient-portal-my-info-address-line-1-input">
              </mat-form-field>
              <mat-form-field class="input-field input-field-full" data-cy="patient-portal-my-info-address-line-2-form-field">
                <mat-label data-cy="patient-portal-my-info-address-line-2-label">Address Line 2</mat-label>
                <input matInput [(ngModel)]="PatientAddress.Address2" data-cy="patient-portal-my-info-address-line-2-input">
              </mat-form-field>
              <mat-form-field class="input-field input-field-medium" style="flex: 1;" data-cy="patient-portal-my-info-city-form-field">
                <mat-label data-cy="patient-portal-my-info-city-label">City</mat-label>
                <input matInput [(ngModel)]="PatientAddress.City" required data-cy="patient-portal-my-info-city-input">
              </mat-form-field>
              <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-my-info-state-form-field">
                <mat-label data-cy="patient-portal-my-info-state-label">State</mat-label>
                <mat-select [(ngModel)]="PatientAddress.enumStateProvinceID" required data-cy="patient-portal-my-info-state-select">
                  @for (option of stateListEnums; track option) {
                    <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-my-info-state-option">
                      {{option.ItemDisplayValue}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="input-field input-field-small" style="flex: 1;" data-cy="patient-portal-my-info-zipcode-form-field">
                <mat-label data-cy="patient-portal-my-info-zipcode-label">Zipcode</mat-label>
                <input matInput [(ngModel)]="PatientAddress.PostCode" required data-cy="patient-portal-my-info-zipcode-input">
              </mat-form-field>
              @if (PatientContactMethodPhone || PatientContactMethodEmail) {
                <div class="input-section-header" data-cy="patient-portal-my-info-contact-method-header">
                  Contact Method
                </div>
              }
              <!-- PatientContactMethodPhone -->
              <div style="display: flex;flex-flow: row;" class="personal-information-contact-method" data-cy="patient-portal-my-info-contact-method-row">
                @if (PatientContactMethodPhone) {
                  <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-my-info-phone-type-form-field">
                    <mat-label data-cy="patient-portal-my-info-phone-type-label">Phone Type</mat-label>
                    <mat-select [(ngModel)]="PatientContactMethodPhone.enumCommMethodID" required data-cy="patient-portal-my-info-phone-type-select">
                      @for (option of enumContactMethods; track option) {
                        <mat-option [value]="option.ValidValueItemId" data-cy="patient-portal-my-info-phone-type-option">
                          {{option.ItemDisplayValue}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (PatientContactMethodPhone) {
                  <mat-form-field class="input-field input-field-medium" data-cy="patient-portal-my-info-phone-number-form-field">
                    @if (isTabletPortrait) {
                      <mat-label data-cy="patient-portal-my-info-phone-number-label-tablet">Phone No.</mat-label>
                    }
                    @if (!isTabletPortrait) {
                      <mat-label data-cy="patient-portal-my-info-phone-number-label-desktop">Phone Number</mat-label>
                    }
                    <input matInput type="tel" [(ngModel)]="PatientContactMethodPhone.Address" required data-cy="patient-portal-my-info-phone-number-input">
                  </mat-form-field>
                }
                @if (PatientContactMethodEmail) {
                  <mat-form-field class="input-field input-field-long" data-cy="patient-portal-my-info-email-form-field">
                    <mat-label data-cy="patient-portal-my-info-email-label">Email</mat-label>
                    <input matInput type="email" [(ngModel)]="PatientContactMethodEmail.Address" required data-cy="patient-portal-my-info-email-input">
                  </mat-form-field>
                }
                @if (PatientContactMethodPhone) {
                  <div class="input-field input-field-long" style="padding-top: 10px;" data-cy="patient-portal-my-info-sms-opt-out-container">
                    <mat-checkbox [(ngModel)]="PatientContactMethodPhone.isOptOut" data-cy="patient-portal-my-info-sms-opt-out-checkbox">Opt-out of SMS messages</mat-checkbox>
                    <div class="sms-opt-out-note" data-cy="patient-portal-my-info-sms-opt-out-message">
                      <i class="material-icons sms-opt-out-note-icon" data-cy="patient-portal-my-info-sms-opt-out-message-icon">info_outline</i>
                      <span>If you previously texted STOP to opt out, you may need to reply START to the office's phone number to receive SMS messages again.</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="tab-navigation-container" data-cy="patient-portal-my-info-personal-information-navigation-container">
            <button mat-button (click)="moveSelectedTab(false)" class="tab-nav-left" data-cy="patient-portal-my-info-personal-information-previous-tab-button"><i
            class="material-icons" data-cy="patient-portal-my-info-personal-information-previous-tab-icon">keyboard_arrow_left</i></button>
            <button mat-button (click)="moveSelectedTab(true)" class="tab-nav-left" data-cy="patient-portal-my-info-personal-information-next-tab-button"><i
            class="material-icons" data-cy="patient-portal-my-info-personal-information-next-tab-icon">keyboard_arrow_right</i></button>
            <button mat-raised-button color="primary" class="tdo-button tdo-save tab-nav-right"
            (click)="saveAllWindows()" data-cy="patient-portal-my-info-personal-information-save-button">Save</button>
          </div>
        </mat-tab>
        <mat-tab label="Contacts" data-cy="patient-portal-my-info-contacts-tab-panel">
          <ng-template mat-tab-label>
            <span data-cy="patient-portal-my-info-contacts-tab">Contacts</span>
          </ng-template>
          <div class="information-container" data-cy="patient-portal-my-info-contacts-container">
            <app-patient-portal-contacts #contactView [disableSaveButton]="true" [PatientId]="PatientId"
            [PatientContact]="PatientContact" [PatientAddress]="PatientAddress" data-cy="patient-portal-my-info-contacts-app-patient-portal-contacts"></app-patient-portal-contacts>
            <div [ngClass]="{ 'extra-bottom-space': isTabletPortrait || isTabletLandscape }" class="tab-navigation-container" data-cy="patient-portal-my-info-contacts-navigation-container">
              <button mat-button (click)="moveSelectedTab(false)" class="tab-nav-left" data-cy="patient-portal-my-info-contacts-previous-tab-button"><i
              class="material-icons" data-cy="patient-portal-my-info-contacts-previous-tab-icon">keyboard_arrow_left</i></button>
              <button mat-button (click)="moveSelectedTab(true)" class="tab-nav-left" data-cy="patient-portal-my-info-contacts-next-tab-button"><i
              class="material-icons" data-cy="patient-portal-my-info-contacts-next-tab-icon">keyboard_arrow_right</i></button>
              <button mat-raised-button color="primary" class="tdo-button tdo-save tab-nav-right"
              (click)="saveAllWindows()" data-cy="patient-portal-my-info-contacts-save-button">Save</button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Insurance" data-cy="patient-portal-my-info-insurance-tab-panel">
          <ng-template mat-tab-label>
            <span data-cy="patient-portal-my-info-insurance-tab">Insurance</span>
          </ng-template>
          <div [ngClass]="isTabletLandscape ? 'information-container-scrollY' :  'information-container'" data-cy="patient-portal-my-info-insurance-container">
            <app-patient-portal-insurance #insuranceView [useImageViewWidth]="true" [imageViewWidth]="getFileViewWidth()"
            [disableSaveButton]="true" [PatientId]="PatientId" data-cy="patient-portal-my-info-insurance-app-patient-portal-insurance"></app-patient-portal-insurance>
            <div [ngClass]="{ 'extra-bottom-space': isTabletPortrait || isTabletLandscape }" class="tab-navigation-container" data-cy="patient-portal-my-info-insurance-navigation-container">
              <button mat-button (click)="moveSelectedTab(false)" class="tab-nav-left" data-cy="patient-portal-my-info-insurance-previous-tab-button"><i
              class="material-icons" data-cy="patient-portal-my-info-insurance-previous-tab-icon">keyboard_arrow_left</i></button>
              <button mat-button (click)="moveSelectedTab(true)" class="tab-nav-left" data-cy="patient-portal-my-info-insurance-next-tab-button"><i
              class="material-icons" data-cy="patient-portal-my-info-insurance-next-tab-icon">keyboard_arrow_right</i></button>
              <button mat-raised-button color="primary" class="tdo-button tdo-save tab-nav-right"
              (click)="saveAllWindows()" data-cy="patient-portal-my-info-insurance-save-button">Save</button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  }

</div>